import cx from "classnames";
import "./Chip.scss";
import { X } from "lucide-react";

type ChipProps = {
  label: string;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  variant?: "default" | "dark";
  "aria-label"?: string;
};

const Chip: React.FC<ChipProps> = ({
  label,
  onClick,
  className,
  style,
  variant = "default",
  "aria-label": ariaLabel,
}) => {
  const chipClasses = cx(
    "Chip",
    {
      "Chip--Default": variant === "default",
      "Chip--Dark": variant === "dark",
    },
    className,
  );

  return onClick ? (
    <button
      className={chipClasses}
      onClick={onClick}
      role="button"
      style={style}
      aria-label={ariaLabel}
    >
      {label && <span className="Chip__Label">{label}</span>}
      <X className="Chip__Icon" />
    </button>
  ) : (
    <span className={chipClasses} onClick={onClick} style={style}>
      {label && <span className="Chip__Label">{label}</span>}
    </span>
  );
};

export { Chip };
